export const toggleLoading = (setter, value) => {
  setter((prevState) => ({
    ...prevState,
    isLoading: value,
  }));
};

export const togglePaginating = (setter, value) => {
  setter((prevState) => ({
    ...prevState,
    isPaginating: value,
  }));
};
